(function () {
  'use strict';
  var root = document.querySelector('[data-dw-native-layout]');
  if (!root || root.dwNativeUIAttached) return;
  root.dwNativeUIAttached = true;
  var panel = root.querySelector('.dw-native-sidebar');
  var opener = root.querySelector('[data-native-open]');
  var form = panel.querySelector('form');
  var breakpoint = window.matchMedia('(max-width: 768px)');
  var previousOverflow = '';
  var wasOpen = false;
  function closePanel(restoreFocus) {
    root.removeAttribute('data-native-panel-open');
    opener.setAttribute('aria-expanded', 'false');
    panel.removeAttribute('role');
    panel.removeAttribute('aria-modal');
    if (wasOpen) document.documentElement.style.overflow = previousOverflow;
    wasOpen = false;
    if (restoreFocus && breakpoint.matches) opener.focus();
  }
  function openPanel() {
    if (!breakpoint.matches) return;
    var header = document.getElementById('SiteHeader');
    var top = header ? Math.max(0, Math.min(header.getBoundingClientRect().bottom, window.innerHeight * 0.3)) : 0;
    root.style.setProperty('--dw-native-drawer-top', Math.round(top) + 'px');
    previousOverflow = document.documentElement.style.overflow;
    root.setAttribute('data-native-panel-open', '');
    opener.setAttribute('aria-expanded', 'true');
    panel.setAttribute('role', 'dialog');
    panel.setAttribute('aria-modal', 'true');
    document.documentElement.style.overflow = 'hidden';
    wasOpen = true;
    panel.querySelector('[data-native-close]').focus();
  }
  opener.addEventListener('click', openPanel);
  root.querySelectorAll('[data-native-close]').forEach(function (button) {
    button.addEventListener('click', function () { closePanel(true); });
  });
  panel.addEventListener('keydown', function (event) {
    if (!wasOpen) return;
    if (event.key === 'Escape') {
      event.preventDefault();
      closePanel(true);
    }
    if (event.key !== 'Tab') return;
    var nodes = Array.from(panel.querySelectorAll('a[href], button, input:not([type="hidden"]), select, summary')).filter(function (node) {
      return !node.disabled && node.getClientRects().length > 0;
    });
    var first = nodes[0], last = nodes[nodes.length - 1];
    if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
    else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
  });
  var sort = root.querySelector('[data-native-sort]');
  sort.addEventListener('change', function () { form.requestSubmit(); });
  root.querySelectorAll('[data-native-price]').forEach(function (choice) {
    choice.addEventListener('change', function () {
      var group = choice.closest('[data-native-price-group]');
      group.querySelector('input[name="filter.v.price.gte"]').value = choice.dataset.min;
      group.querySelector('input[name="filter.v.price.lte"]').value = choice.dataset.max;
    });
  });
  root.querySelectorAll('.dw-collection-fallback__price input').forEach(function (input) {
    input.addEventListener('input', function () {
      input.closest('[data-native-price-group]').querySelector('[data-native-price-custom]').checked = true;
    });
  });
  breakpoint.addEventListener('change', function () { closePanel(false); });
  window.addEventListener('pagehide', function () { closePanel(false); });
  root.setAttribute('data-native-ui-ready', '');
}());
